import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

/**
 * IST Pipe — Converts UTC to IST (Indian Standard Time, UTC+5:30)
 * Usage: {{ dateValue | ist:'format' }}
 * Example: {{ checkInTime | ist:'dd MMM yyyy, hh:mm a' }}
 */
@Pipe({
  name: 'ist',
  standalone: true
})
export class IstPipe implements PipeTransform {
  private datePipe = new DatePipe('en-IN'); // India locale

  transform(value: any, format: string = 'dd MMM yyyy, hh:mm a'): string | null {
    if (!value) return null;

    try {
      // Angular's date pipe with timezone 'Asia/Kolkata' (IST)
      return this.datePipe.transform(value, format, 'Asia/Kolkata') || null;
    } catch (e) {
      console.warn(`IST Pipe error for value:`, value, e);
      return null;
    }
  }
}
